<template>
  <f7-page @page:init="onPageInit">
    <f7-navbar :back-link="$t('back')">
      <f7-nav-title>{{ $t("edit") }}</f7-nav-title>
      <langButton></langButton>
    </f7-navbar>
    <f7-card class="procard" outline>
      <f7-card-header class="no-border">
        <div
          v-if="editForm.Cover != null && editForm.Cover != ''"
          class="coverimg"
          :style="{
            backgroundImage: 'url(' + baseCoverUrl + editForm.Cover + ')',
          }"
        ></div>
        <div class="title">
          {{ $field(editForm.Name) }}
        </div>
        <div class="price">s${{ editForm.Price }}</div>
      </f7-card-header>
      <f7-card-content>
        {{ $field(editForm.Introduce) }}
      </f7-card-content>
    </f7-card>
    <f7-list inline-labels no-hairlines-md form ref="form">
      <f7-list-input
        :label="$t('Product.LowestNumber')"
        type="number"
        :placeholder="$t('pleaseEnter') + $t('Product.LowestNumber')"
        required
        validate
        :value="editForm.LowestNumber"
        @input="editForm.LowestNumber = parseInt($event.target.value)"
        inputmode="numeric"
        min="1"
      >
      </f7-list-input>
      <f7-list-input
        :label="$t('Product.MaxNumber')"
        type="number"
        :placeholder="$t('pleaseEnter') + $t('Product.MaxNumber')"
        required
        validate
        :value="editForm.MaxNumber"
        @input="editForm.MaxNumber = parseInt($event.target.value)"
        inputmode="numeric"
        info="0为不限"
      >
      </f7-list-input>
      <f7-list-item>
        <span>{{ $t("Reco") }}</span>
        <f7-toggle
          :checked="editForm.Reco"
          @change="editForm.Reco = $event.target.checked"
          color="orange"
        ></f7-toggle>
      </f7-list-item>
      <f7-list-item>
        <span>{{ $t("Hot") }}</span>
        <f7-toggle
          :checked="editForm.Hot"
          @change="editForm.Hot = $event.target.checked"
          color="orange"
        ></f7-toggle>
      </f7-list-item>
      <f7-list-item>
        <span>{{ $t("status") }}</span>
        <f7-toggle
          :checked="editForm.Enabled"
          @change="editForm.Enabled = $event.target.checked"
          color="orange"
        ></f7-toggle>
      </f7-list-item>
    </f7-list>
    <f7-block>
      <f7-button fill large :loading="isLoading" @click="editSubmit">
        {{ $t("save") }}
      </f7-button>
    </f7-block>
  </f7-page>
</template>
<script>
import util from "util/date";
import { base, getProductInfo, editProduct } from "@/api/api";
import { f7 } from "framework7-vue";
export default {
  props: {
    f7route: Object,
    f7router: Object,
  },
  data() {
    return {
      Name: "可派商城订单",
      Balance: 0,
      Freeze: 0,
      editForm: {},
      isLoading: false,
      baseCoverUrl: base + "/FileUpload/Product/a0/",
    };
  },
  methods: {
    editSubmit() {
      if (!f7.input.validateInputs("form")) {
        return;
      }
      f7.dialog.confirm(this.$t("submitPrompt"), this.$t("prompt"), () => {
        this.isLoading = true;
        let para = Object.assign({}, this.editForm);
        editProduct(para).then((res) => {
          this.isLoading = false;
          if (res.data.success) {
            f7.dialog.alert("提交成功", () => {
              this.f7router.back("/Product", {
                ignoreCache: true,
                force: true,
              });
            });
          } else {
            f7.toast
              .create({
                icon: '<i class="f7-icons">multiply</i>',
                text: res.data.msg,
                position: "center",
                closeTimeout: 2000,
              })
              .open();
          }
        });
      });
    },
    onPageInit() {
      let para = {
        id: this.f7route.params.id,
      };
      f7.preloader.show();
      getProductInfo(para).then((res) => {
        f7.preloader.hide();
        this.editForm = res.data.response;
      });
    },
  },
};
</script>
<style scoped>
.procard .title {
  margin-left: 5px;
  font-size: 14px;
  font-weight: 500;
  width: calc(100% - 125px);
}
.procard .price {
  width: 60px;
  color: #ff3b30;
  text-align: right;
}
</style>